// src/pages/Landing/LandingPage.jsx
import React, { useState, useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import LandingHeader from "../../components/LandingHeader/LandingHeader";
import "./Landing.css";

export default function LandingPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const heroRef = useRef(null);

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (searchParams.get("scrollTo") === "hero" && heroRef.current) {
      heroRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [searchParams]);

  return (
    <div className={`landingPage-container${isScrolled ? " landingPage--scrolled" : ""}`}>
      <LandingHeader />

      <div className="landingPage-bgFixed" />

      <main className="landingPage-main">
        <section ref={heroRef} className="landingPage-hero">
          {/* tu contenido de hero irá aquí */}
        </section>
      </main>
    </div>
  );
}
